export default "__VITE_PUBLIC_ASSET__b4ca99a9__"